import { ModelConstants } from '../model-constants';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { SalesforceV2LinkedService } from './salesforce-v2.linkedservice';
import { format, getConnectorV2Name } from '../../shared/utils/string.util';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';


@Metamodel.model({
    name: ModelConstants.salesforceServiceCloudV2LinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, getConnectorV2Name(shellStringResources.SalesforceServiceCloud_DisplayText, isTridentInIframe())),
        format(shellStringResources.ModelName_LinkedServicesTemplate, getConnectorV2Name(shellStringResources.SalesforceServiceCloud_DisplayText, isTridentInIframe()))
    ]
})
export class SalesforceServiceCloudV2LinkedService extends SalesforceV2LinkedService {}
